import styled from 'styled-components';


const CompanyUserFooterSection =  styled.div`
  && {
    ${props => props.theme.CompanyUserFooterSection};
  }
`;

export default CompanyUserFooterSection;